/*
 * @Author: huangyf huangyf@efly.cc
 * @Date: 2022-03-03 10:32:36
 * @LastEditors: huangyf huangyf@efly.cc
 * @LastEditTime: 2024-07-23 09:59:42
 * @FilePath: \agent\manage\main\src\components\login-footer\login-footer.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {Component, Prop, Vue, Emit} from 'vue-property-decorator';
import common from '../../../../common/src/assets/js/common';
import Service from '../../../../common/src/assets/service/service';

@Component
export default class LoginFooter extends Vue {
    @Prop() type!: string;
    public $router: any;
    private test: any;
    private config = {
        service_tel: '',
        service_qq: '',
        copyright: '',
        message_sign: '',
        companyLogo: '',
        qrcode: '',
        friendLinkName: '',
        friendLinkUrl: '',
    }
    mounted() {
        setTimeout(() => {
            let SystemInfoData = sessionStorage.getItem('front_systemInfo');
            if (typeof SystemInfoData === 'string' && SystemInfoData && SystemInfoData!='undefined') {
                let SystemInfo = JSON.parse(SystemInfoData);
                this.config.service_tel = SystemInfo.serviceTel;
                this.config.service_qq = SystemInfo.serviceQQ;
                this.config.copyright = SystemInfo.copyright;
                this.config.friendLinkName = SystemInfo.friendLinkName;
                this.config.friendLinkUrl = SystemInfo.friendLinkUrl;
                this.config.message_sign = SystemInfo.messageSign;
            }
        }, 500)
    }
}
